import React from "react";
import close from "../../../assets/images/model/close.svg";
const UploadingImages = ({
  setSelectedMediaType,
  setSelectedUploadingImag,
  setUploadedImag,
}) => {
  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_book"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_bookLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                onClick={() => {
                  setSelectedMediaType(false);
                  setSelectedUploadingImag(false);
                }}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src={close} alt="close" />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>add image</h4>

              <form action="" className="upload_book">
                <div className="upload_book_inner my-40 mb-0">
                  <div
                    className="drag_and_drop_box upload-boarder"
                    htmlFor="Drag-file"
                  >
                    <div className="upload_content">
                      <div className="icon mb-24"> </div>
                      <div className="deflat_content">
                        <div
                          className="circle"
                          onClick={() => {
                            setUploadedImag(true);
                            setSelectedUploadingImag(false);
                          }}
                        >
                          <b>
                            <span>50%</span>
                          </b>
                        </div>
                        <h6 className="f-size-18 theme__primary__text">
                          Uploading image...
                        </h6>
                      </div>
                    </div>
                  </div>
                  {/*  <div className="error_text error-create">
                    Oops, that file is too large to upload. Max file size is
                    1GB. Please try again.
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadingImages;
